module.exports = __webpack_public_path__ + "img/trusted.be2f82b.png";